'use client';

import { usePathname } from 'next/navigation';
import { Sidebar } from './Sidebar';
import { SwipeBack } from './SwipeBack';

export function LayoutShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const isReaderPage = pathname === '/reader';

  if (isReaderPage) {
    return (
      <>
        <SwipeBack />
        {children}
      </>
    );
  }

  return (
    <>
      <SwipeBack />
      <Sidebar />
      <div className="lg:pl-64">
        {children}
      </div>
    </>
  );
}
